import React from 'react';
import styles from "./toggleButton.module.css";

function ToggleButton({ checked,handleChange, labelClassName,...props }) {
  return (
    <label className={`${styles.switch} ${labelClassName && labelClassName}`}>
      <input
        type="checkbox"
        className={styles.input}
        onChange={(e)=>handleChange && handleChange(e)}       
        checked={checked}
        {...props}  
      />
      <span className={`${styles.slider} ${styles.round}`}></span>
    </label>
  );
}

export default ToggleButton;
